import { Component } from '@angular/core';

@Component({
  selector: 'app-combo-discount-info',
  templateUrl: './combo-discount-info.component.html',
  styleUrl: './combo-discount-info.component.scss',
})
export class ComboDiscountInfoComponent {}
